const onAgendaPageMatch = () => {
  const titleInputSelector =
    '.ant-collapse-content-box .TextInput .ant-form-item-control-input-content input'
  const descriptionInputSelector =
    '.ant-collapse-content-box .RichTextEditor .jodit-wysiwyg'

  const waitForPageLoad = setInterval(async () => {
    const pageContent = document.querySelector('.AgendaItemDetails')
    if (pageContent) {
      clearInterval(waitForPageLoad)

      const { templates } = await getImpowerXData(
        `${baseApiUrl}/api/impowerX/resolution-templates`
      )

      const observer = new MutationObserver((mutations) => {
        let dropdownSelector = null
        let dropdownSelectorId = null
        const spans = document.querySelectorAll('.SelectInput span')
        const selectedSpan = Array.from(spans).find(
          (span) => span.textContent.trim() === 'Vorlage auswählen'
        )

        if (selectedSpan) {
          const dropdownSelectorName = selectedSpan
            .closest('.SelectInput')
            ?.querySelector('input')
            ?.getAttribute('aria-owns')

          if (dropdownSelectorName) {
            const match = dropdownSelectorName.match(/rc_select_(\d+)_list/)
            if (match) dropdownSelectorId = match[1]

            dropdownSelector = `#${dropdownSelectorName} + .rc-virtual-list .rc-virtual-list-holder-inner`
          }
        }

        if (
          !!dropdownSelector &&
          $(dropdownSelector).length > 0 &&
          templates?.length > 0
        ) {
          // add the templates to the dropdown and disconnect the observer

          const templatesMarkup = templates.map(
            (template) => `
            <div aria-selected="false" class="ant-select-item ant-select-item-option resolution-template-option" data-id="${template.id}" title="${template.title}">
              <div class="ant-select-item-option-content">
                <div class="select-menu-item">${template.name}</div>
              </div>
              <span class="ant-select-item-option-state" unselectable="on" aria-hidden="true" style="user-select: none;"></span>
            </div>
          `
          )

          $(dropdownSelector).append(templatesMarkup.join(''))

          observer.disconnect()
        }

        $('.resolution-template-option').on('mouseenter', function () {
          if (!$(this).hasClass('ant-select-item-option-disabled')) {
            $(this).addClass('ant-select-item-option-active')
          }
        })

        $('.resolution-template-option').on('mouseleave', function () {
          $(this).removeClass('ant-select-item-option-active')
        })

        let isAutoSelecting = false

        $(`${dropdownSelector} .ant-select-item`).on('click', function () {
          if ($(this).hasClass('resolution-template-option')) {
            const templateId = $(this).data('id')
            if (!templateId) return

            const template = templates.find(
              (template) => template.id === templateId
            )

            // focus the input to hide the dropdown menu
            $(titleInputSelector).trigger('focus')
            const input = document.querySelector(titleInputSelector)

            // Get the native property descriptor for 'value'
            const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
              window.HTMLInputElement.prototype,
              'value'
            ).set
            // Use it to set the value
            nativeInputValueSetter.call(input, template.title)
            // Dispatch an 'input' event to notify React
            input.dispatchEvent(new Event('input', { bubbles: true }))

            const allSelectBoxes =
              document.querySelectorAll('[id^="rc_select_"]')

            const filtered = Array.from(allSelectBoxes).find((el) => {
              const match = el.id.match(/^rc_select_(\d+)$/)
              return match && match[1] !== dropdownSelectorId
            })

            const selectedResolutionType = $(`#${filtered.id}`)
              .closest('.ant-select-selector')
              .find('.ant-select-selection-item')
              .text()

            const slectionBox = $(
              '.ant-collapse-content-box .ant-select-in-form-item.Select'
            ).last()

            if (slectionBox.length > 0) {
              if (
                $(slectionBox).find('.ant-select-selection-item').length > 0
              ) {
                $(slectionBox)
                  .find('.ant-select-selection-item')
                  .text(template.title)
              } else {
                $(slectionBox).find('.ant-select-selection-placeholder').hide()
                $(slectionBox)
                  .find('.ant-select-selector')
                  .append(
                    `<span class="ant-select-selection-item impower-x-template-selection" title="${template.title}">${template.title}</span>`
                  )
              }
            }

            // Check current field contents
            const currentDescription = $(descriptionInputSelector).first().html().trim()
            const currentResolutionText = $(descriptionInputSelector).last().html().trim()
            
            // Check if we need to ask for confirmation (any field has content that would be overwritten)
            // Only show confirmation for user-initiated clicks, not auto-selection
            const hasDescriptionContent = currentDescription && currentDescription !== ''
            const hasResolutionContent = currentResolutionText && currentResolutionText !== ''
            const templateHasDescription = template.description && template.description.trim()
            const templateHasResolution = template.resolutionText && template.resolutionText.trim() && selectedResolutionType !== 'Diskussion ohne Beschluss'
            
            const needsConfirmation = !isAutoSelecting && ((hasDescriptionContent && templateHasDescription) || (hasResolutionContent && templateHasResolution))
            
            let shouldOverwrite = true
            if (needsConfirmation) {
              shouldOverwrite = confirm(
                'Die Textfelder zur Beschlussvorlage enthalten bereits Text. Möchten Sie diese mit der Vorlage überschreiben?'
              )
            }
            
            // Apply template content if confirmed or no confirmation needed
            if (shouldOverwrite) {
              // Handle description field
              if (templateHasDescription) {
                $(descriptionInputSelector).first().html(template.description)
                document.querySelector(descriptionInputSelector).focus()
              }
              
              // Handle resolution text field
              if (selectedResolutionType === 'Diskussion ohne Beschluss') {
                // Clear resolution text for discussion without resolution
                $(descriptionInputSelector).last().html('')
              } else if (templateHasResolution) {
                $(descriptionInputSelector).last().html(template.resolutionText)
                document.querySelectorAll(descriptionInputSelector)[1].focus()
              }
            }

            input.focus()
          } else {
            $('.impower-x-template-selection').remove()
          }
        })

        const defaultResolutionDescription = $(descriptionInputSelector)
          .last()
          .html()

        if (defaultResolutionDescription && templates.length > 0) {
          const template = templates.find(
            (template) =>
              template.resolutionText === defaultResolutionDescription
          )

          if (template && selectedSpan) {
            isAutoSelecting = true
            $(selectedSpan)
              .closest('.SelectInput')
              ?.find('.ant-select-selector')
              ?.trigger('click')

            $(`.resolution-template-option[data-id="${template.id}"]`).trigger(
              'click'
            )
            isAutoSelecting = false
          }
        }
      })

      observer.observe(document.body, {
        subtree: true,
        childList: true,
      })

      const observer2 = new MutationObserver((mutations) => {
        let dropdownSelector = null
        const spans = document.querySelectorAll('.SelectInput span')
        const selectedSpan = Array.from(spans).find(
          (span) => span.textContent.trim() === 'Art *'
        )

        if (selectedSpan) {
          dropdownSelector = selectedSpan
            .closest('.SelectInput')
            ?.querySelector('input')
            ?.getAttribute('aria-owns')

          if (dropdownSelector) {
            dropdownSelector = `#${dropdownSelector} + .rc-virtual-list .rc-virtual-list-holder-inner .ant-select-item`
          }
        }

        if (!!dropdownSelector && $(dropdownSelector).length > 0) {
          $(dropdownSelector).on('click', function () {
            if ($(this).text() !== 'Beschlussantrag') {
              $(descriptionInputSelector).last().html('')
            }

            observer2.disconnect()
          })
        }
      })

      observer2.observe(document.body, {
        subtree: true,
        childList: true,
      })
    }
  }, 100)
}
